import { css } from "@compiled/react";
import { useIntl, FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { Button } from "@/components/wpl/button/src/button";
import { Link } from "@/libraries/design/components/link/src/link";
import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";
import { DataEventProps } from "@/libraries/wpl/foundations/src/data-event-props";

const jiraFeatureCTASectionStyle = css({
    padding: "16px 0 64px 0",
    position: "relative",
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    minWidth: "100%",
    clear: "both"
});

const ctaSectionTextStyle = css({
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    marginBlockStart: "15px",
    padding: `${token("space.400")} ${token("space.200")} ${token("space.200")}
        ${token("space.200")}`
});

const ctaSectionTextStyleHeading = css({
    verticalAlign: "baseline",
    marginBlockEnd: "16px",
    lineHeight: "1.33333333",
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#253858",
    marginBlockStart: "0",
    letterSpacing: ".3px",
    fontWeight: "500",

    [media.below.sm]: {
        fontSize: "1.25rem"
    },
    [media.above.sm]: {
        fontSize: "1.5rem"
    }
});

const ctaSectionTextStyleButton = css({
    margin: `${token("space.0")} ${token("space.0")} ${token("space.200")}
    ${token("space.0")}`,
    fontWeight: "500",
    minHeight: 40,
    textWrap: "wrap",
    verticalAlign: "baseline",
    whiteSpaceCollapse: "collapse"
});

const ctaSectionlinkStyle = css({
    lineHeight: "16px",
    fontSize: "16px"
});

const CTASection = () => {
    const intl = useIntl();
    const getItFreeText = intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.heroCTA",
        defaultMessage: "Get it free"
    });

    const linkDataEventProps: DataEventProps = {
        "data-event-component": "linkButton",
        "data-event-container": "ctaSection",
        "data-event": "clicked",
        "data-product-key": "jiraSoftware"
    };

    return (
        <section>
            <div css={jiraFeatureCTASectionStyle}>
                <div css={ctaSectionTextStyle}>
                    <h3 css={ctaSectionTextStyleHeading}>
                        <FormattedMessage
                            id="JiraSoftwareFeaturesPage.ctaSection.header"
                            defaultMessage="Get started with Jira Software"
                        />
                    </h3>
                    <Button
                        text={getItFreeText}
                        aria-label={getItFreeText}
                        css={ctaSectionTextStyleButton}
                        color="darkblue"
                        url={useLocalizedHref("/software/jira/free")}
                        dataEventProps={{
                            "data-product-key": "jiraSoftwareFeature",
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-label": getItFreeText
                        }}
                    />
                    {/* eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name */}
                    <Link
                        css={ctaSectionlinkStyle}
                        type="anchor"
                        href={useLocalizedHref("/software/jira/pricing")}
                        text={intl.formatMessage({
                            id: "JiraSoftwareFeaturesPage.ctaSection.seePricing",
                            defaultMessage: "See pricing"
                        })}
                        bgColor="bgWhite"
                        dataEventProps={linkDataEventProps}
                    />
                </div>
            </div>
        </section>
    );
};

export default CTASection;
